function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1649_1764)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 23.1998C18.1856 23.1998 23.2 18.1854 23.2 11.9998C23.2 5.81422 18.1856 0.799805 12 0.799805C5.8144 0.799805 0.799988 5.81422 0.799988 11.9998C0.799988 18.1854 5.8144 23.1998 12 23.1998Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.46126 11.9027C5.46126 11.9027 11.0613 9.60448 13.0035 8.79523C13.748 8.47153 16.2728 7.43569 16.2728 7.43569C16.2728 7.43569 17.4381 6.98251 17.341 8.08309C17.3087 8.53627 17.0497 10.1224 16.7907 11.838C16.4023 14.2657 15.9815 16.9201 15.9815 16.9201C15.9815 16.9201 15.9167 17.6646 15.3665 17.7941C14.8162 17.9236 13.9098 17.3409 13.748 17.2114C13.6185 17.1143 11.3202 15.6577 10.4786 14.9455C10.252 14.7513 9.99305 14.3629 10.511 13.9097C11.6763 12.8415 13.0682 11.5143 13.9098 10.6727C14.2983 10.2842 14.6867 9.37789 13.0682 10.4785C10.7699 12.0646 8.50403 13.5536 8.50403 13.5536C8.50403 13.5536 7.98611 13.8773 7.01502 13.586C6.04392 13.2946 4.91097 12.9062 4.91097 12.9062C4.91097 12.9062 4.13409 12.4207 5.46126 11.9027Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1649_1764"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22.4,
  height: 22.4,
  fill: "white",
  transform: "translate(0.799988 0.799805)"
})));

function SvgTele(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.748b637f.svg";
export { ForwardRef as ReactComponent };